import React, { useState, useEffect } from 'react';
import { Alert } from '@amzn/awsui-components-react-v3';

export const EmptyContent = props => {
  return (
    <Alert header="No Reports to Show">Create a report using the sidebar to begin.</Alert>
  )
}


// WEBPACK FOOTER //
// ./src/components/spotcp/emptyContent.jsx